import { disconnectRfqClientGatewayStream } from '@/composables/rfq/gateway/clientPrerequisites'
import {
  WALLET_CLEANUP_IDS,
  WALLET_CLEANUP_ORDER,
  registerWalletCleanup
} from '@/app/services/walletCleanup'
import { TcCtaToast } from '@/types'

export const registerDefaultWalletCleanups = () => {
  registerWalletCleanup({
    id: WALLET_CLEANUP_IDS.auth,
    order: WALLET_CLEANUP_ORDER.auth,
    cleanup: async () => {
      await useAuthStore().logout()
    }
  })

  registerWalletCleanup({
    id: WALLET_CLEANUP_IDS.app,
    order: WALLET_CLEANUP_ORDER.app,
    cleanup: () => {
      useAppStore().reset()
    }
  })

  registerWalletCleanup({
    id: WALLET_CLEANUP_IDS.rfqClientGateway,
    order: WALLET_CLEANUP_ORDER.rfqClientGateway,
    cleanup: async () => {
      await disconnectRfqClientGatewayStream()
    }
  })

  registerWalletCleanup({
    id: WALLET_CLEANUP_IDS.sharedWallet,
    order: WALLET_CLEANUP_ORDER.sharedWallet,
    cleanup: async () => {
      await useSharedWalletStore().logout()
    }
  })

  registerWalletCleanup({
    id: WALLET_CLEANUP_IDS.subaccount,
    order: WALLET_CLEANUP_ORDER.subaccount,
    cleanup: async () => {
      await useSubaccountStore().resetSubaccount()
    }
  })

  registerWalletCleanup({
    id: WALLET_CLEANUP_IDS.exchange,
    order: WALLET_CLEANUP_ORDER.exchange,
    cleanup: () => {
      useExchangeStore().reset()
    }
  })

  registerWalletCleanup({
    id: WALLET_CLEANUP_IDS.account,
    order: WALLET_CLEANUP_ORDER.account,
    cleanup: async () => {
      await useAccountStore().reset()
    }
  })

  registerWalletCleanup({
    id: WALLET_CLEANUP_IDS.activity,
    order: WALLET_CLEANUP_ORDER.activity,
    cleanup: () => {
      useActivityStore().$reset()
    }
  })

  registerWalletCleanup({
    id: WALLET_CLEANUP_IDS.position,
    order: WALLET_CLEANUP_ORDER.position,
    cleanup: () => {
      usePositionStore().$reset()
    }
  })

  registerWalletCleanup({
    id: WALLET_CLEANUP_IDS.referral,
    order: WALLET_CLEANUP_ORDER.referral,
    cleanup: () => {
      useReferralStore().$reset()
    }
  })

  registerWalletCleanup({
    id: WALLET_CLEANUP_IDS.authZ,
    order: WALLET_CLEANUP_ORDER.authZ,
    cleanup: () => {
      useAuthZStore().$reset()
    }
  })

  registerWalletCleanup({
    id: WALLET_CLEANUP_IDS.access,
    order: WALLET_CLEANUP_ORDER.access,
    cleanup: () => {
      useAccessStore().$reset()
    }
  })

  registerWalletCleanup({
    id: WALLET_CLEANUP_IDS.notification,
    order: WALLET_CLEANUP_ORDER.notification,
    cleanup: () => {
      useSharedNotificationStore().close(TcCtaToast.Announcements)
    }
  })

  registerWalletCleanup({
    id: WALLET_CLEANUP_IDS.wallet,
    order: WALLET_CLEANUP_ORDER.wallet,
    cleanup: () => {
      useWalletStore().resetAutoSignSetup()
    }
  })
}
